import { render, staticRenderFns } from "./HeaderControlsAddProject.vue?vue&type=template&id=57f2b9da&scoped=true&"
import script from "./HeaderControlsAddProject.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsAddProject.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsAddProject.vue?vue&type=style&index=0&id=57f2b9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2b9da",
  null
  
)

export default component.exports